import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=a553c8fe&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=js"
export * from "./Reset.vue?vue&type=script&lang=js"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=a553c8fe&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a553c8fe",
  null
  
)

export default component.exports